export default __webpack_public_path__ + "static/media/leadtree.d6b95b10.png";